import { render, staticRenderFns } from "./ProspeccionJobbers.vue?vue&type=template&id=6b44e04a"
import script from "./ProspeccionJobbers.vue?vue&type=script&lang=js"
export * from "./ProspeccionJobbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports